import { createI18n } from 'vue-i18n'
import { getConfig } from './config'

import zhs from './locales/zhs.json'
import zht from './locales/zht.json'
import nl from './locales/nl.json'
import en from './locales/en.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import it from './locales/it.json'
import ja from './locales/ja.json'
import pt from './locales/pt.json'
import ptb from './locales/ptb.json'
import es from './locales/es.json'

export default createI18n({
  locale:
    localStorage.getItem('ui-language') ?? getConfig('VUE_APP_DEFAULT_LOCALE'),
  fallbackLocale: getConfig('VUE_APP_FALLBACK_LOCALE'),
  messages: {
    zhs: zhs,
    zht: zht,
    nl: nl,
    en: en,
    fr: fr,
    de: de,
    it: it,
    ja: ja,
    pt: pt,
    ptb: ptb,
    es: es,
  },
  legacy: false,
})
